import { convertFromHTML, ContentState, EditorState, Modifier } from 'draft-js';
import { stateToHTML } from 'draft-js-export-html';

export const initializeEditorWith = (htmlContent) => {
  if (htmlContent) {
    const blocksFromHtml = convertFromHTML(htmlContent);
    const contentBlocks = blocksFromHtml.contentBlocks;
    const entityMap = blocksFromHtml.entityMap;
    if (contentBlocks == null || contentBlocks == undefined || contentBlocks.length === 0) {
      return EditorState.createEmpty();
    }
    const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
    return EditorState.createWithContent(contentState);
  }

  return EditorState.createEmpty();
};

export const generateHtmlFrom = (editorState) => {
  if (editorState) {
    const contentState = editorState.getCurrentContent();
    return stateToHTML(contentState);
  }
  return null;
};

export const pastePartialTextIntoEditor = (text, editorStateParam) => {
  if (text && editorStateParam) {
    const selection = editorStateParam.getSelection();
    const contentState = editorStateParam.getCurrentContent();
    let nextEditorState = EditorState.createEmpty();
    let nextContentState = null;
    if (selection.isCollapsed()) {
      // No block selection
      nextContentState = Modifier.insertText(contentState, selection, text);
      nextEditorState = EditorState.push(editorStateParam, nextContentState, 'insert-characters');
    } else {
      nextContentState = Modifier.replaceText(contentState, selection, text);
      nextEditorState = EditorState.push(editorStateParam, nextContentState, 'change-block-data');
    }
    return nextEditorState;
  }

  return EditorState.createEmpty();
};

export const generateEmptyEditor = currentEditorState =>
  EditorState.push(currentEditorState, ContentState.createFromText(''), 'remove-range');

export const insertTextIntoTextAreaField = (textToInsert, field, textAreaCursor, callback) => {
  if (textAreaCursor) {
    const elemValue = field.input.value;
    let result = null;

    if (textAreaCursor.selectionStart || textAreaCursor.selectionStart === '0') {
      const startPos = textAreaCursor.selectionStart;
      const endPos = textAreaCursor.selectionEnd;
      result = elemValue.substring(0, startPos)
            + textToInsert
            + elemValue.substring(endPos, elemValue.length);
    } else {
      result = elemValue + textToInsert;
    }
    field.input.onChange(result);
    if (callback) {
      callback();
    }
  }
};
